import React from 'react';
import {
    Typography,
    Button,
    Box,
    Card,
    CardContent,
    makeStyles
} from '@material-ui/core';
import { Error, Refresh } from '@material-ui/icons';
import { useStateValue } from '../context/state/provider';
import { VIEW } from '../constants/view.constants';

const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafe', // Match wizard background for consistency
        padding: theme.spacing(2)
    },
    card: {
        maxWidth: 600,
        padding: theme.spacing(4),
        textAlign: 'center',
        borderRadius: theme.spacing(2)
    },
    errorIcon: {
        fontSize: 80,
        color: theme.palette.error.main,
        marginBottom: theme.spacing(2)
    },
    title: {
        marginBottom: theme.spacing(2),
        color: theme.palette.error.main
    },
    description: {
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary
    },
    errorDetails: {
        textAlign: 'left',
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.error.light,
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.error.contrastText
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2)
    }
}));

export default function ErrorView() {
    const classes = useStyles();
    const [{ error }, dispatch] = useStateValue();

    // Check if this is a token expiration error
    const isTokenExpired = error && (
        error.includes('expired') || 
        error.includes('Wizard link has expired') ||
        error.includes('Invalid wizard link')
    );

    return (
        <div className={classes.container}>
            <Card className={classes.card}>
                <CardContent>
                    <Error className={classes.errorIcon} />
                    
                    <Typography variant="h4" className={classes.title}>
                        {isTokenExpired ? 'Session Expired' : 'Something went wrong'}
                    </Typography>
                    
                    <Typography variant="body1" className={classes.description}>
                        {isTokenExpired 
                            ? 'Your wizard session has expired. Please close this tab and generate a new wizard link from the admin panel.' 
                            : 'We encountered an error while creating your agent. Please try again.'}
                    </Typography>

                    {error && (
                        <Box className={classes.errorDetails}>
                            <Typography variant="body2">
                                <strong>Error details:</strong><br />
                                {error}
                            </Typography>
                        </Box>
                    )}

                    {/* Only show Try Again button for non-token errors */}
                    {!isTokenExpired && (
                        <Box className={classes.buttonContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    dispatch({ type: 'SET_ERROR', error: null });
                                    dispatch({ type: 'SET_VIEW', view: VIEW.WIZARD });
                                }}
                                startIcon={<Refresh />}
                            >
                                Try Again
                            </Button>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
